import { TableCell, TableHeader, Table as TablePDF } from '@ag-media/react-pdf-table';
import { Text } from '@react-pdf/renderer';

import { formatNumber } from 'utils';
import styles from '../style-sheet';

interface ITableProps {
  tableData: any[];
}

const Table = ({ tableData }: ITableProps) => {
  return (
    <TablePDF>
      <TableHeader>
        <TableCell weighting={0.1} style={styles.tableHeader}>
          <Text style={{ ...styles.textExSmallBold, fontSize: 10, fontWeight: 700 }}>DATE</Text>
        </TableCell>
        <TableCell weighting={0.9}>
          <TablePDF weightings={[0.18, 0.18, 0.1, 0.27, 0.27]}>
            <TableHeader>
              <TableCell style={{ ...styles.tableHeader, justifyContent: 'center' }}>
                <Text style={{ ...styles.textExSmallBold, fontSize: 10, fontWeight: 700 }}>
                  CHECK IN
                </Text>
              </TableCell>
              <TableCell style={{ ...styles.tableHeader, justifyContent: 'center' }}>
                <Text style={{ ...styles.textExSmallBold, fontSize: 10, fontWeight: 700 }}>
                  CHECK OUT
                </Text>
              </TableCell>
              <TableCell style={{ ...styles.tableHeader, justifyContent: 'center' }}>
                <Text style={{ ...styles.textExSmallBold, fontSize: 10, fontWeight: 700 }}>
                  O.O.O
                </Text>
              </TableCell>
              <TableCell style={{ ...styles.tableHeader, justifyContent: 'center' }}>
                <Text style={{ ...styles.textExSmallBold, fontSize: 10, fontWeight: 700 }}>
                  OCCUPIED
                </Text>
              </TableCell>
              <TableCell style={{ ...styles.tableHeader, justifyContent: 'center' }}>
                <Text style={{ ...styles.textExSmallBold, fontSize: 10, fontWeight: 700 }}>
                  FINANCIALS
                </Text>
              </TableCell>
            </TableHeader>
            <TableHeader>
              <TableCell
                weighting={0.11}
                style={{ ...styles.tableHeader, justifyContent: 'center' }}
              >
                <Text style={{ ...styles.textExSmallBold, fontSize: 9, fontWeight: 700 }}>
                  Room
                </Text>
              </TableCell>
              <TableCell
                weighting={0.076}
                style={{ ...styles.tableHeader, justifyContent: 'center' }}
              >
                <Text style={{ ...styles.textExSmallBold, fontSize: 9, fontWeight: 700 }}>
                  Guest
                </Text>
              </TableCell>
              <TableCell
                weighting={0.11}
                style={{ ...styles.tableHeader, justifyContent: 'center' }}
              >
                <Text style={{ ...styles.textExSmallBold, fontSize: 9, fontWeight: 700 }}>
                  Room
                </Text>
              </TableCell>
              <TableCell
                weighting={0.076}
                style={{ ...styles.tableHeader, justifyContent: 'center' }}
              >
                <Text style={{ ...styles.textExSmallBold, fontSize: 9, fontWeight: 700 }}>
                  Guest
                </Text>
              </TableCell>
              <TableCell
                weighting={0.115}
                style={{ ...styles.tableHeader, justifyContent: 'center' }}
              >
                <Text style={{ ...styles.textExSmallBold, fontSize: 9, fontWeight: 700 }}>
                  Room
                </Text>
              </TableCell>
              <TableCell
                weighting={0.09}
                style={{ ...styles.tableHeader, justifyContent: 'center' }}
              >
                <Text style={{ ...styles.textExSmallBold, fontSize: 9, fontWeight: 700 }}>
                  Room
                </Text>
              </TableCell>
              <TableCell
                weighting={0.09}
                style={{ ...styles.tableHeader, justifyContent: 'center' }}
              >
                <Text style={{ ...styles.textExSmallBold, fontSize: 9, fontWeight: 700 }}>
                  %OCC
                </Text>
              </TableCell>
              <TableCell
                weighting={0.09}
                style={{ ...styles.tableHeader, justifyContent: 'center' }}
              >
                <Text style={{ ...styles.textExSmallBold, fontSize: 9, fontWeight: 700 }}>
                  Guest
                </Text>
              </TableCell>
              <TableCell
                weighting={0.09}
                style={{ ...styles.tableHeader, justifyContent: 'center' }}
              >
                <Text style={{ ...styles.textExSmallBold, fontSize: 9, fontWeight: 700 }}>
                  Revenue
                </Text>
              </TableCell>
              <TableCell
                weighting={0.09}
                style={{ ...styles.tableHeader, justifyContent: 'center' }}
              >
                <Text style={{ ...styles.textExSmallBold, fontSize: 9, fontWeight: 700 }}>ADR</Text>
              </TableCell>
              <TableCell
                weighting={0.09}
                style={{ ...styles.tableHeader, justifyContent: 'center' }}
              >
                <Text style={{ ...styles.textExSmallBold, fontSize: 9, fontWeight: 700 }}>
                  Net Profit
                </Text>
              </TableCell>
            </TableHeader>
          </TablePDF>
        </TableCell>
      </TableHeader>
      {tableData &&
        tableData.map(row => (
          <TableHeader key={row.date}>
            <TableCell
              weighting={0.1}
              style={{ ...styles.tableHeader, backgroundColor: 'transparent' }}
            >
              <Text style={{ fontSize: 10 }}>{row.date}</Text>
            </TableCell>
            <TableCell weighting={0.9}>
              <TablePDF
                weightings={[0.18, 0.18, 0.1, 0.27, 0.27]}
                tdStyle={{ border: '1px solid transparent' }}
              >
                <TableHeader>
                  <TableCell
                    weighting={0.11}
                    style={{
                      ...styles.tableHeader,
                      justifyContent: 'center',
                      backgroundColor: 'transparent'
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>{row.check_in?.room}</Text>
                  </TableCell>
                  <TableCell
                    weighting={0.076}
                    style={{
                      ...styles.tableHeader,
                      backgroundColor: 'transparent',
                      justifyContent: 'center'
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>{row.check_in?.pax}</Text>
                  </TableCell>
                  <TableCell
                    weighting={0.11}
                    style={{
                      ...styles.tableHeader,
                      justifyContent: 'center',
                      backgroundColor: 'transparent'
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>{row.check_out?.room}</Text>
                  </TableCell>
                  <TableCell
                    weighting={0.076}
                    style={{
                      ...styles.tableHeader,
                      justifyContent: 'center',
                      backgroundColor: 'transparent'
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>{row.check_out?.pax}</Text>
                  </TableCell>
                  <TableCell
                    weighting={0.115}
                    style={{
                      ...styles.tableHeader,
                      justifyContent: 'center',
                      backgroundColor: 'transparent'
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>{row.rooms_locked || 0}</Text>
                  </TableCell>
                  <TableCell
                    weighting={0.09}
                    style={{
                      ...styles.tableHeader,
                      justifyContent: 'center',
                      backgroundColor: 'transparent'
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>{row.occupied?.room}</Text>
                  </TableCell>
                  <TableCell
                    weighting={0.09}
                    style={{
                      ...styles.tableHeader,
                      justifyContent: 'center',
                      backgroundColor: 'transparent'
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>{row.occupied?.occupied_percent}%</Text>
                  </TableCell>
                  <TableCell
                    weighting={0.09}
                    style={{
                      ...styles.tableHeader,
                      justifyContent: 'center',
                      backgroundColor: 'transparent'
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>{row.occupied?.pax}</Text>
                  </TableCell>
                  <TableCell
                    weighting={0.09}
                    style={{
                      ...styles.tableHeader,
                      justifyContent: 'center',
                      backgroundColor: 'transparent'
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>
                      {formatNumber(Math.round(row.financials?.revenue))}
                    </Text>
                  </TableCell>
                  <TableCell
                    weighting={0.09}
                    style={{
                      ...styles.tableHeader,
                      justifyContent: 'center',
                      backgroundColor: 'transparent'
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>
                      {formatNumber(Math.round(row.financials?.gross_profit))}
                    </Text>
                  </TableCell>
                  <TableCell
                    weighting={0.09}
                    style={{
                      ...styles.tableHeader,
                      justifyContent: 'center',
                      backgroundColor: 'transparent'
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>
                      {formatNumber(Math.round(row.financials?.net_profit))}
                    </Text>
                  </TableCell>
                </TableHeader>
              </TablePDF>
            </TableCell>
          </TableHeader>
        ))}
    </TablePDF>
  );
};

export default Table;
